import ApiHelper from "./ApiHelper"

export const LoginApi = {
    login: async (payload) => {
        let result = await ApiHelper.post("/login", payload)
        return result.data
    },
    validToken: async (payload) => {
        let result = await ApiHelper.post("/validToken", payload)
        if (result)
            return result.data
        else
            return null
    },
    fetchDaiGioChot: async () => {
        let result = await ApiHelper.get("/danhmuc/getDaiGioChot")
        if (result)
            return result.data
        else
            return null
    },
    getUserFullInfo: async () => {
        let result = await ApiHelper.get("/user/getUserFullInfo")
        if (result)
            return result.data
        else
            return null
    },
    getNearestAgentContact: async () => {
        let result = await ApiHelper.get("/user/getNearestAgentContact")
        if (result)
            return result.data
        else
            return null
    },
    updateSuDungTinAndroid: async (suDung) => {
        let result = await ApiHelper.post(`/user/updateSuDungTinAndroid?suDungTinAndroid=${suDung}`)
        if (result)
            return result.data
        else
            return null
    },
    updateSuDungTinBot: async (suDung) => {
        let result = await ApiHelper.post(`/user/updateSuDungTinBot?suDungTinBot=${suDung}`)
        if (result)
            return result.data
        else
            return null
    },
    updateVaiTroBot: async (vaiTroBot) => {
        const url = `/user/updateVaiTroBot?vaiTroBot=${vaiTroBot}`
        let result = await ApiHelper.post(url)
        if (result)
            return result.data
        else
            return null
    },
    updateSapXepTin: async (sapXep) => {
        let result = await ApiHelper.post(`/user/updateSapXepTin?sapXepTin=${sapXep}`)
        if (result)
            return result.data
        else
            return null
    },
    checkExpire: async () => {
        let result = await ApiHelper.get("/user/checkExpire")
        if (result)
            return result.data
        else
            return null
    },
}